// What Copilot shows for text it typed: the length only. The text can be a
// password, and both the chat history and the pill over the desktop are on
// screen for anyone watching.
export function typedTextLabel(text) {
  const count = Array.from(String(text)).length;
  return `Typed ${count} ${count === 1 ? "character" : "characters"}`;
}
